import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import IndeterminateCheckbox from 'components/base/IndeterminateCheckbox';
import StarCheckbox from 'components/base/StarCheckbox';
import { Email } from 'data/email';
import { getFileIcon } from 'helpers/utils';
import { useBulkSelect } from 'pages/template/providers/BulkSelectProvider';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MyResource } from './DataDefinitions';
//import { UilFile, UilImage, UilFileAlt, UilFilePdf, UilMusic, UilVideo } from '@iconscout/react-unicons';
import {
  faFile,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileAlt
} from "@fortawesome/free-solid-svg-icons";


const getResourceIcon = (meta: string): JSX.Element => {
  try {
    const parsedMeta = JSON.parse(meta);
    const contentType = parsedMeta["content-type"] || "";

    if (contentType.startsWith("image/")) return <FontAwesomeIcon icon={faFileImage} />;
    if (contentType.startsWith("video/")) return <FontAwesomeIcon icon={faFileVideo} />;
    if (contentType.startsWith("audio/")) return <FontAwesomeIcon icon={faFileAudio} />;
    if (contentType === "application/pdf") return <FontAwesomeIcon icon={faFilePdf} />;
    if (contentType.includes("word") || contentType.includes("msword")) return <FontAwesomeIcon icon={faFileWord} />;
    if (contentType.includes("excel")) return <FontAwesomeIcon icon={faFileExcel} />;
    if (contentType.includes("text") || contentType.includes("plain")) return <FontAwesomeIcon icon={faFileAlt} />;

    return <FontAwesomeIcon icon={faFile} />; // Default file icon
  } catch (error) {
    return <FontAwesomeIcon icon={faFile} />; // Fallback if parsing fails
  }
};

const getResourceSize = (meta: string): string => {
  try {
    const parsedMeta = JSON.parse(meta);
    const fileSize = parsedMeta["file-size"] || 0;
    const fileSizeKB = Math.round(fileSize / 1024 * 10) / 10
    if (fileSizeKB > 1023) return Math.round(fileSize / (1024 * 1024) * 10) / 10 + " MB"
    return fileSizeKB + " KB"
  } catch (error) {
    return "- KB"
  }
};

interface MyResourceRowProps {
  resource: MyResource;
  index: number;
}

const MyResourceRow = ({ resource, index }: MyResourceRowProps) => {
  const { getRowCheckboxProps } = useBulkSelect();
  return (
    <div className="border-bottom hover-actions-trigger py-3">
      <Row className="gx-2">
        <Col xs="auto">
          <div className="d-flex flex-column flex-sm-row">
            <IndeterminateCheckbox
              {...getRowCheckboxProps(String(index))}
              className="mb-2 m-sm-0 me-sm-2"
            />
            <Button className="btn p-0">
              <StarCheckbox defaultChecked={resource.starred === 1} iconClass="fs-9" />
            </Button>
          </div>
        </Col>
        <Col className="col-auto">
          {getResourceIcon(resource.meta)}
        </Col>
        <Col className="col-auto">
          <Link
            to="#!"

            className={'fs-9 inbox-link text-900 fw-semi-bold'}
          >
            {resource.resource_name}
          </Link>
        </Col>
        <Col className="col-auto ms-auto">
          <div className="hover-actions end-0">
            <Dropdown>
              <Dropdown.Toggle
                variant="phoenix-secondary"
                className="dropdown-caret-none btn-icon"
              >
                <FontAwesomeIcon icon={faEllipsis} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#!">Mark Important</Dropdown.Item>
                <Dropdown.Item href="#!">Archive</Dropdown.Item>
                <Dropdown.Item href="#!">Download</Dropdown.Item>
                <Dropdown.Item href="#!">Print</Dropdown.Item>
                <Dropdown.Item href="#!" className="text-danger">
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <span
            className={'fs-10'}
          >
            {getResourceSize(resource.meta)}
          </span>
        </Col>
      </Row>
      <div className="ms-4 mt-n3 mt-sm-0 ms-sm-11">
        <Link to="/apps/email/email-detail" className="d-block inbox-link">
          <span
            className={'fs-9 line-clamp-1 text-1000'}
          >
            {resource.resource_type}
          </span>
          <p className="fs-9 ps-0 text-700 mb-0 line-clamp-2">
            {resource.resource_uri}
          </p>
        </Link>

      </div>
    </div>
  );
};

export default MyResourceRow;
